import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { Activity } from '@nxtpeople/nxt-styles';
import { LocationQuery } from 'vue-router';
import { Hit } from './hit.interface';

class HIT_INCLUDES_CLASS {
   all: Record<'includes' | 'appends', Array<string>> = {
      includes: ['team', 'user', 'tenant', 'customer', 'candidate', 'position', 'appointments', 'propositions', 'status'],
      appends: [],
   };
   activity: Record<'includes' | 'appends', Array<string>> = {
      includes: ['appointments', 'propositions', 'status', 'status.status_type', 'status.hit_sub_status_type'],
      appends: [],
   };

   constructor() {}

   check(includes: Record<'includes' | 'appends', Array<string>>, name: string): boolean {
      const includesDiff = includes.includes.filter((i) => !this.all.includes.includes(i));
      const appendsDiff = includes.appends.filter((i) => !this.all.appends.includes(i));

      if (includesDiff.length || appendsDiff.length) {
         console.group(`CANDIDATE_INCLUDES_CLASS: ${name}`);
         console.info('Missing includes:', includesDiff);
         console.info('Missing appends:', appendsDiff);
         console.groupEnd();
      }

      return !includesDiff.length && !appendsDiff.length;
   }
}

export const HIT_INCLUDES = new HIT_INCLUDES_CLASS();

export class HitService {
   async postHit(hit: Hit) {
      const response = await http.post<ApiResource<Hit>>(`/hits`, hit);
      return response.data;
   }
   async getHitActivities(hitId: number, query: LocationQuery) {
      const response = await http.get<ApiResource<Activity>>(`/hits/${hitId}/activities`, {
         params: { ...query },
      });
      return response.data;
   }
   async patchHit(hitId: number, path: string, value: string | boolean | null | number) {
      const response = await http.patch<ApiResource<Hit>>(`/hits/${hitId}`, {
         [path]: value,
         include: HIT_INCLUDES.all.includes,
      });
      return response.data;
   }
   async deleteHit(hitId: number) {
      const response = await http.delete<ApiResource<Hit>>(`/hits/${hitId}`);
      return response;
   }
   async deleteHitBulk(hitIds: Array<number>) {
      const response = await http.delete<ApiResource<Array<number>>>(`/hits`, { data: { ids: hitIds } });
      return response;
   }
}
